import React from 'react';

const PaymentSection = ({ title, children }) => {
  return (
    <div className="payment-section">
      <h3>{title}</h3>
      {children}
    </div>
  );
};

export default PaymentSection; 